export default __webpack_public_path__ + "static/media/defipulse.120f92ca.png";